import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || (process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : 'http://localhost:5000/api');

const userService = {
    /**
     * Obtiene el perfil del usuario actual
     */
    getMe: async (token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const res = await axios.get(`${API_URL}/users/me`, config);
        return res.data;
    },

    /**
     * Actualiza el perfil del usuario (básico + profesional + foto)
     */
    updateProfile: async (formData, token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        const res = await axios.put(`${API_URL}/users/profile`, formData, config);
        return res.data;
    },

    /**
     * Obtiene todos los investigadores
     */
    getResearchers: async (token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const res = await axios.get(`${API_URL}/users/researchers`, config);
        return res.data;
    },

    /**
     * Obtiene todos los pacientes
     */
    getPatients: async (token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const res = await axios.get(`${API_URL}/users/patients`, config);
        return res.data;
    },

    /**
     * Obtiene el perfil detallado de un investigador
     */
    getResearcherProfile: async (id, token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const res = await axios.get(`${API_URL}/users/details/${id}`, config);
        return res.data;
    },

    // ── CONNECTIONS ──
    getPendingConnections: async (token) => {
        const res = await axios.get(`${API_URL}/connections/pending`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    getSentPendingConnections: async (token) => {
        const res = await axios.get(`${API_URL}/connections/sent-pending`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    sendConnectionRequest: async (recipientId, token) => {
        const res = await axios.post(`${API_URL}/connections/request`, { recipientId }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    respondToConnection: async (id, status, token) => {
        const res = await axios.put(`${API_URL}/connections/respond/${id}`, { status }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    getContacts: async (token) => {
        const res = await axios.get(`${API_URL}/connections/contacts`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    }
};

export default userService;
